import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import "moment-timezone";
import PageContainer from "pages/container";
import TabBar from "components/tab-bar";
import SubNavTab from "components/sub-nav-tab";
import Match from "components/match";
import LoadingBar from "components/loading-bar";
import { getMatchesRequest } from "actions/pages/matches";
import { SEASON_ID, CURRENT_WEEK } from "config";

/*const TAB_PRESEASON = {
  id: 0,
  title: "Pre",
};*/

const TAB_WEEK_1 = {
  id: 1,
  title: "W1",
};

const TAB_WEEK_2 = {
  id: 2,
  title: "W2",
};

const TAB_WEEK_3 = {
  id: 3,
  title: "W3",
};

const TAB_WEEK_4 = {
  id: 4,
  title: "W4",
};

const TAB_WEEK_5 = {
  id: 5,
  title: "W5",
};

/*const TAB_WEEK_6 = {
  id: 6,
  title: "W6",
};

const TAB_WEEK_7 = {
  id: 7,
  title: "W7",
};

const TAB_WEEK_8 = {
  id: 8,
  title: "W8",
};*/

/*const TAB_QF = {
  id: 9,
  title: "QUARTER-FINALS",
};*/

const TAB_SF = {
  id: 6,
  title: "SEMI-FINALS",
};

const TAB_F = {
  id: 7,
  title: "FINALS",
};

const TABS = [
  //TAB_PRESEASON,
  TAB_WEEK_1,
  TAB_WEEK_2,
  TAB_WEEK_3,
  TAB_WEEK_4,
  TAB_WEEK_5,
  // TAB_WEEK_6,
  // TAB_WEEK_7,
  // TAB_WEEK_8,
  // TAB_QF,
  TAB_SF,
  TAB_F,
];

let FILTER_SQUAD_ALL = "all";

let FILTER_SQUAD_OPTIONS = [];

const FILTER_TYPE_ALL = "all";
const FILTER_TYPE_TWCD = "TWLD";
const FILTER_TYPE_TWCJ = "TWLJ";
const FILTER_TYPE_TWCB = "TWLB";

const FILTER_TYPE_OPTIONS = [
  {
    id: FILTER_TYPE_ALL,
    title: "All",
  },
  {
    id: FILTER_TYPE_TWCD,
    title: "TWCD",
  },
  {
    id: FILTER_TYPE_TWCJ,
    title: "TWCJ",
  },
  {
    id: FILTER_TYPE_TWCB,
    title: "TWCB",
  },
];

const FILTER_STATUS_ALL = "all";
const FILTER_STATUS_UPCOMING = "upcoming";
const FILTER_STATUS_FINISHED = 1;
const FILTER_STATUS_VOIDED = 3;
const FILTER_STATUS_FORFEIT = 2;
const FILTER_STATUS_REPLAYED = 4;
const FILTER_STATUS_APPEALED = 5;

const FILTER_STATUS_OPTIONS = [
  {
    id: FILTER_STATUS_ALL,
    title: "All",
  },
  {
    id: FILTER_STATUS_UPCOMING,
    title: "Upcoming",
  },
  {
    id: FILTER_STATUS_FINISHED,
    title: "Finished",
  },
  {
    id: FILTER_STATUS_VOIDED,
    title: "Void",
  },
  {
    id: FILTER_STATUS_APPEALED,
    title: "Appealed",
  },
  {
    id: FILTER_STATUS_FORFEIT,
    title: "Forfeits",
  },
  {
    id: FILTER_STATUS_REPLAYED,
    title: "Replays",
  },
];

class Matches extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: TABS.find((t) => t.id === CURRENT_WEEK),
      filterSquad: FILTER_SQUAD_ALL,
      filterType: FILTER_TYPE_ALL,
      filterStatus: FILTER_STATUS_ALL,
    };
  }

  componentDidMount() {
    const { app, dispatch } = this.props;
    const { selectedTab } = this.state;

    const week = selectedTab.id;

    FILTER_SQUAD_OPTIONS = [
      {
        id: FILTER_SQUAD_ALL,
        title: "All",
      },
    ];

    app.teams.forEach((team) => {
      FILTER_SQUAD_OPTIONS.push({
        id: team.fnTeamID,
        title: team.fcTeamName,
      });
    });

    dispatch(getMatchesRequest(SEASON_ID, week));
  }

  selectTab = (tab) => {
    const { dispatch } = this.props;
    const { selectedTab } = this.state;

    const week = tab.id;

    if (selectedTab !== tab) {
      this.setState(
        {
          selectedTab: tab,
        },
        () => {
          dispatch(getMatchesRequest(SEASON_ID, week));
        }
      );
    }
  };

  updateFilterSquad = (e) => {
    this.setState({
      ...this.state,
      filterSquad: e.target.value,
    });
  };

  updateFilterType = (e) => {
    this.setState({
      ...this.state,
      filterType: e.target.value,
    });
  };

  updateFilterStatus = (e) => {
    this.setState({
      ...this.state,
      filterStatus: e.target.value,
    });
  };

  render() {
    const { page } = this.props;
    const { matches, requests } = page;
    const { selectedTab, filterSquad, filterType, filterStatus } = this.state;

    let content;
    let headerContent;
    let innerContent;
    let filteredMatches = [];
    let noMatches = <p className="intro">No matches available.</p>;

    if (requests.getMatches.success) {
      if (matches.length) {
        headerContent = (
          <div>
            <h3>
              {moment(matches[0].ftDateTimeUTC).format("dddd, D MMMM YYYY")}
            </h3>
            <p className="intro">
              All dates are shown in your local timezone ({moment.tz.guess()}).
            </p>
            <form>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Filter:</label>
                </div>
                <div className="field-body">
                  <div className="field is-narrow">
                    <div className="control">
                      <div className="select is-fullwidth">
                        <select
                          value={filterSquad}
                          onChange={this.updateFilterSquad}
                        >
                          <optgroup label="Squads">
                            {FILTER_SQUAD_OPTIONS.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.title}
                              </option>
                            ))}
                          </optgroup>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="field is-narrow">
                    <div className="control">
                      <div className="select is-fullwidth">
                        <select
                          value={filterType}
                          onChange={this.updateFilterType}
                        >
                          <optgroup label="Type">
                            {FILTER_TYPE_OPTIONS.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.title}
                              </option>
                            ))}
                          </optgroup>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="field is-narrow">
                    <div className="control">
                      <div className="select is-fullwidth">
                        <select
                          value={filterStatus}
                          onChange={this.updateFilterStatus}
                        >
                          <optgroup label="Status">
                            {FILTER_STATUS_OPTIONS.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.title}
                              </option>
                            ))}
                          </optgroup>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        );

        if (matches.length) {
          filteredMatches = matches;

          if (filterSquad !== FILTER_SQUAD_ALL) {
            filteredMatches = filteredMatches.filter(
              (match) =>
                match.team1.fnTeamID.toString() === filterSquad ||
                match.team2.fnTeamID.toString() === filterSquad
            );
          }

          if (filterType !== FILTER_TYPE_ALL) {
            filteredMatches = filteredMatches.filter(
              (match) => match.match_type.fcMatchTypeName === filterType
            );
          }

          if (filterStatus !== FILTER_STATUS_ALL) {
            if (filterStatus === FILTER_STATUS_UPCOMING) {
              filteredMatches = filteredMatches.filter(
                (match) => match.match === null
              );
            } else {
              filteredMatches = filteredMatches.filter(
                (match) => match.match !== null
              );
              filteredMatches = filteredMatches.filter(
                (match) =>
                  match.match.league_match.fnMatchStatusTypeID.toString() ===
                  filterStatus
              );
            }
          }

          if (filteredMatches.length) {
            innerContent = (
              <div>
                {filteredMatches.map((match) => {
                  return <Match key={match.fnScheduleID} {...match} />;
                })}
              </div>
            );
          } else {
            innerContent = noMatches;
          }

          content = (
            <div className="content">
              {headerContent}
              {innerContent}
            </div>
          );
        } else {
          content = noMatches;
        }
      } else {
        content = noMatches;
      }
    } else {
      content = <LoadingBar />;
    }

    return (
      <PageContainer
        className="matches"
        title="Matches"
        subtitle="All past and upcoming matches"
      >
        <TabBar>
          {TABS.map((tab) => (
            <SubNavTab
              key={tab.id}
              {...tab}
              onClick={() => {
                this.selectTab(tab);
              }}
              selected={selectedTab === tab}
            />
          ))}
        </TabBar>
        {content}
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
  page: state.pages.matches,
});

export default connect(mapStateToProps)(Matches);



// WEBPACK FOOTER //
// ./src/pages/matches/matches.js